// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2459":"2335824ebaa59684","5948":"b5429893e4eb7820"}[chunkId] + ".css";
};